import icHome from "assets/images/PageContainer/IconFooter/ic_home.svg";
import icCart from "assets/images/PageContainer/IconFooter/ic_cart.svg";
import icUser from "assets/images/PageContainer/IconFooter/ic_user.svg";

import icHomeActive from "assets/images/PageContainer/IconFooter/ic_home_active.svg";
import icCartActive from "assets/images/PageContainer/IconFooter/ic_cart_active.svg";
import icUserActive from "assets/images/PageContainer/IconFooter/ic_user_active.svg";

import icHomeActiveTP from "assets/images/PageContainer/IconFooter/ic_home_active_TP.svg";
import icCartActiveTP from "assets/images/PageContainer/IconFooter/ic_cart_active_TP.svg";
import icUserActiveTP from "assets/images/PageContainer/IconFooter/ic_user_active_TP.svg";

import icHomeActiveCake from "assets/images/PageContainer/IconFooter/ic_home_active_cake.svg";
import icCartActiveCake from "assets/images/PageContainer/IconFooter/ic_cart_active_cake.svg";
import icUserActiveCake from "assets/images/PageContainer/IconFooter/ic_user_active_cake.svg";

//HOME PAGE
import icNotification from "assets/images/HomePage/ic_notification.svg";
import icAvatar from "assets/images/HomePage/ic_avatar.svg";
import icPurchase from "assets/images/HomePage/ic_purchase.svg";
import icCartWeek from "assets/images/HomePage/ic_cart.svg";
import icInfoWhite from "assets/images/HomePage/ic_info_white.svg";
import icDollar from "assets/images/HomePage/ic_dollar.png";
import icProgressChart from "assets/images/HomePage/ic_progress_chart.png";
import icSuccess from "assets/images/HomePage/ic_success.png";
import icCopperLevel1 from "assets/images/HomePage/ic_copper_level_1.png";
import bgSpecialOffers from "assets/images/HomePage/bg_special_offers.svg";
import icSpecialOffers from "assets/images/HomePage/ic_special_offers.svg";
import bgHistoryOrder from "assets/images/HomePage/bg_history_order.svg";
import icHistoryOrder from "assets/images/HomePage/ic_history_order.svg";
import icProductDefault from "assets/images/HomePage/ic_product_default.png";
import bannerLoyalty from "assets/images/HomePage/bg_loyalty.png";
import icResetPassword from "assets/images/HomePage/ic_reset_password.svg";
import logoNonNoti from "assets/images/HomePage/logo_non_noti.svg";
import icNextNoti from "assets/images/HomePage/ic_next_noti.svg";
import icConfirmCRM from "assets/images/HomePage/ic_confirm_CRM.svg";
import btnLoyalty from "assets/images/HomePage/btn_loyalty.png";

import icNotificationActive from "assets/images/HomePage/ic_notification_active.svg";

//FIND_PAGE
import icNonProduct from "assets/images/FindPage/ic_non_product.svg";
import icMagnifyingGlass from "assets/images/FindPage/ic_magnifying_glass.svg";

//CART_PAGE
import icGift from "assets/images/CartPage/ic_gift.svg";
import icNonCart from "assets/images/CartPage/ic_non_cart.svg";
import icGiftSuccess from "assets/images/CartPage/ic_gift_success.svg";
import icGiftError from "assets/images/CartPage/ic_gift_error.svg";
import icBgPrice from "assets/images/CartPage/ic_bg_price.svg";
import icGiftYellow from "assets/images/CartPage/ic_gift_yellow.svg";
import icLoyalty from "assets/images/CartPage/ic_loyalty.svg";
import bannerBronze from "assets/images/CartPage/banner_bronze.png";
import bannerGold from "assets/images/CartPage/banner_gold.png";
import bannerSilver from "assets/images/CartPage/banner_silver.png";

//USER_PAGE
import icAgreementMinutes from "assets/images/UserPage/ic_agreement_minutes.svg";
import icChangePassword from "assets/images/UserPage/ic_change_password.svg";
import icChat from "assets/images/UserPage/ic_chat.svg";
import icDeleteUser from "assets/images/UserPage/ic_delete_user.svg";
import icFaceId from "assets/images/UserPage/ic_face_id.svg";
import icHotline from "assets/images/UserPage/ic_hotline.svg";
import icInfoUser from "assets/images/UserPage/ic_info_user.svg";
import icLogout from "assets/images/UserPage/ic_logout.svg";
import icNote from "assets/images/UserPage/ic_note.svg";
import bgUser from "assets/images/UserPage/bg_user.png";
import icCheckCircle from "assets/images/UserPage/ic_check_circle.svg";
import icWarningCircle from "assets/images/UserPage/ic_warning_circle.svg";
import logoFeedBack from "assets/images/UserPage/logo_feed_back.svg";

//ORDER_HISTORY
import icCopy from "assets/images/OrderHistory/ic_copy.svg";
import icBarcode from "assets/images/OrderHistory/ic_barcode.svg";
import icClock from "assets/images/OrderHistory/ic_clock.svg";
import icMoney from "assets/images/OrderHistory/ic_money.svg";
import icBgGift from "assets/images/OrderHistory/ic_bg_gift.svg";
import icLoyaltyReward from "assets/images/OrderHistory/ic_loyalty_reward.svg";
import icMerchangdisingReward from "assets/images/OrderHistory/ic_merchangdising_reward.svg";
import icBought from "assets/images/OrderHistory/ic_bought.svg";

//INFOMATION_PAGE
import icCamera from "assets/images/InformationStorePage/ic_camera.svg";
import icWarning from "assets/images/InformationStorePage/ic_warning.svg";
import icBgUser from "assets/images/InformationStorePage/ic_bg_user.svg";
import icBgNote from "assets/images/InformationStorePage/ic_bg_note.svg";
import icCameraV2 from "assets/images/InformationStorePage/ic_camera_v2.svg";
import icCameraAdd from "assets/images/InformationStorePage/ic_camera_add.svg";

//SPECIAL_OFFER_PAGE
import titleCampaign from "assets/images/SpecialOfferPage/title_campaign.png";
import bgCampaign from "assets/images/SpecialOfferPage/bg_campaign.svg";
import icCampaign from "assets/images/SpecialOfferPage/ic_campaign.svg";
import logoCampaignGift from "assets/images/SpecialOfferPage/logo_campaign_gift.png";
import logoCampaignPercent from "assets/images/SpecialOfferPage/logo_campaign_percent.png";
import logoLoyalty from "assets/images/SpecialOfferPage/logo_loyalty.png";
import logoMerchandising from "assets/images/SpecialOfferPage/logo_merchandising.png";
import logoMoney from "assets/images/SpecialOfferPage/logo_money.png";
import logoOther from "assets/images/SpecialOfferPage/logo_other.png";
import titleLoyalty from "assets/images/SpecialOfferPage/title_loyalty.png";
import bgLoyalty from "assets/images/SpecialOfferPage/bg_loyalty.svg";
import titleMerchandising from "assets/images/SpecialOfferPage/title_merchandising.png";
import bgMerchandising from "assets/images/SpecialOfferPage/bg_merchandising.svg";
import icInfoBlue from "assets/images/SpecialOfferPage/ic_info_blue.svg";

//SPECIAL_OFFER_DETAIL_PAGE
import icDocument from "assets/images/SpecialOfferDetailPage/ic_document.svg";
import icSubtitle from "assets/images/SpecialOfferDetailPage/ic_subtitle.svg";
import bannerPointLoyalty from "assets/images/SpecialOfferDetailPage/banner_point_loyalty.png";
import icTimer from "assets/images/SpecialOfferDetailPage/ic_timer.svg";

//GIFT_EXCHANGE_PAGE
// import bgPoint from "assets/images/GiftExchangePage/bg_point.svg";
import bgPoint from "assets/images/GiftExchangePage/bg_point.png";
import bgGift from "assets/images/GiftExchangePage/bg_gift.png";
import bgVoucher from "assets/images/GiftExchangePage/bg_voucher.png";
import logoNonData from "assets/images/GiftExchangePage/logo_non_data.png";
import icCaretDown from "assets/images/GiftExchangePage/ic_caret_down.svg";
import icVoucher from "assets/images/GiftExchangePage/ic_voucher.svg";

//LOGIN_PAGE
import bgLogin from "assets/images/LoginPage/bg_login.svg";
import icEyeLogin from "assets/images/LoginPage/ic_eye_login.svg";
import icFooterLogin from "assets/images/LoginPage/ic_footer_login.svg";
import icLockLogin from "assets/images/LoginPage/ic_lock_login.svg";
import icTuongan from "assets/images/LoginPage/ic_tuongan.svg";
import icUserLogin from "assets/images/LoginPage/ic_user_login.svg";
import icWarningLogin from "assets/images/LoginPage/ic_warning_login.svg";
import icWarningChangePasss from "assets/images/LoginPage/ic_warning.svg";

//GLOBAL_PAGE
import networkError from "assets/images/GlobalPage/network_error.png";
import icLoadding from "assets/images/GlobalPage/loadding.gif";
import ic404 from "assets/images/GlobalPage/404.png";
import icArrowLeftBlack from "assets/images/GlobalPage/ic_arrow_left_black.svg";
import logoError from "assets/images/GlobalPage/logo_error.png";
import icArrowForward from "assets/images/GlobalPage/ic_arrow_forward.svg";
import logoVerify from "assets/images/GlobalPage/logo_verify.png";

//REGISTER_PAGE
import icCreatePassword from "assets/images/RegisterPage/ic_create_password.png";
import logoDeleteAccount from "assets/images/RegisterPage/logo_delete_account.png";
import icCalendar from "assets/images/RegisterPage/ic_calendar.svg";

//NOTIFICATION_PAGE
import icLoyaltyNoti from "assets/images/NotificationPage/ic_loyalty_noti.svg";
import icOrderNoti from "assets/images/NotificationPage/ic_order_noti.svg";
import icPromotionNoti from "assets/images/NotificationPage/ic_promotion_noti.svg";
import icMerchandisingNoti from "assets/images/NotificationPage/ic_merchandising_noti.svg";
import icNewsNoti from "assets/images/NotificationPage/ic_news_noti.svg";
import icSettingNoti from "assets/images/NotificationPage/ic_setting_noti.svg";

//VERIFY_DEVICE
import verifyDevice from "assets/images/VerifyDevicePage/verify_device.png";
import verifyDeviceError from "assets/images/VerifyDevicePage/verify_device_error.png";
import verifyDeviceSuccess from "assets/images/VerifyDevicePage/verify_device_success.png";
import verifyDeviceLock from "assets/images/VerifyDevicePage/verify_device_lock.png";
import bgDeviceActive from "assets/images/VerifyDevicePage/bg_device_active.png";
import bgDevice from "assets/images/VerifyDevicePage/bg_device.png";
import city from "assets/images/VerifyDevicePage/city.png";
import cityActive from "assets/images/VerifyDevicePage/city_active.png";

//CHANGE_PASSWORD
import changePassword from "assets/images/ChangePassword/change_password.png";
import changePasswordSVG from "assets/images/ChangePassword/change_password.svg";

export const Images = {
	icHome,
	icCart,
	icUser,

	icHomeActive,
	icCartActive,
	icUserActive,

	icHomeActiveTP,
	icCartActiveTP,
	icUserActiveTP,

	icHomeActiveCake,
	icCartActiveCake,
	icUserActiveCake,

	//HOME
	icNotification,
	icAvatar,
	icPurchase,
	icCartWeek,
	icInfoWhite,
	icDollar,
	icProgressChart,
	icSuccess,
	icCopperLevel1,
	bgSpecialOffers,
	icSpecialOffers,
	bgHistoryOrder,
	icHistoryOrder,
	icProductDefault,
	bannerLoyalty,
	icResetPassword,
	logoNonNoti,
	icConfirmCRM,
	btnLoyalty,

	icNotificationActive,
	//END HOME

	//FIND_PAGE
	icNonProduct,
	icMagnifyingGlass,
	//END_FIND_PAGE

	//CART_PAGE
	icGift,
	icNonCart,
	icGiftSuccess,
	icGiftError,
	icBgPrice,
	icGiftYellow,
	icLoyalty,
	bannerBronze,
	bannerGold,
	bannerSilver,
	//END_CART_PAGE

	//USER_PAGE
	icAgreementMinutes,
	icChangePassword,
	icChat,
	icDeleteUser,
	icFaceId,
	icHotline,
	icInfoUser,
	icLogout,
	icNote,
	bgUser,
	icCheckCircle,
	icWarningCircle,
	logoFeedBack,
	icNextNoti,
	//END_USER_PAGE

	//ORDER_HISTORY
	icCopy,
	icBarcode,
	icClock,
	icMoney,
	icBgGift,
	icLoyaltyReward,
	icMerchangdisingReward,
	icBought,
	//END_ORDER_HISTORY

	//INFOMATION_PAGE
	icCamera,
	icWarning,
	icBgUser,
	icBgNote,
	icCameraV2,
	icCameraAdd,
	//END_INFOMATION_PAGE

	//SPECIAL_OFFER_PAGE
	titleCampaign,
	bgCampaign,
	logoCampaignGift,
	logoCampaignPercent,
	logoLoyalty,
	logoMerchandising,
	logoMoney,
	logoOther,
	icCampaign,
	titleLoyalty,
	bgLoyalty,
	titleMerchandising,
	bgMerchandising,
	icInfoBlue,
	//END_SPECIAL_OFFER_PAGE

	//SPECIAL_OFFER_DETAIL_PAGE
	icDocument,
	icSubtitle,
	bannerPointLoyalty,
	icTimer,
	//END_SPECIAL_OFFER_DETAIL_PAGE

	//GIFT_EXCHANGE_PAGE
	bgPoint,
	bgGift,
	bgVoucher,
	logoNonData,
	icCaretDown,
	icVoucher,
	//END_GIFT_EXCHANGE_PAGE

	//LOGIN_PAGE
	bgLogin,
	icEyeLogin,
	icFooterLogin,
	icLockLogin,
	icTuongan,
	icUserLogin,
	icWarningLogin,
	icWarningChangePasss,
	//END_LOGIN_PAGE

	//GLOBAL_PAGE
	networkError,
	icLoadding,
	ic404,
	icArrowLeftBlack,
	logoError,
	icArrowForward,
	logoVerify,
	//END_GLOBAL_PAGE

	//REGISTER_PAGE
	icCreatePassword,
	logoDeleteAccount,
	icCalendar,
	//END_REGISTER_PAGE

	//NOTIFICATION_PAGE
	icLoyaltyNoti,
	icOrderNoti,
	icPromotionNoti,
	icMerchandisingNoti,
	icNewsNoti,
	icSettingNoti,
	//END_NOTIFICATION_PAGE

	// VERIFY_DEVICE
	verifyDevice,
	verifyDeviceError,
	verifyDeviceSuccess,
	verifyDeviceLock,
	bgDeviceActive,
	bgDevice,
	city,
	cityActive,
	// END_VERIFY_DEVICE

	//CHANGE_PASSWORD
	changePassword,
	changePasswordSVG
	//END_CHANGE_PASSWORD
};
